import {
  Close,
  Edit,
  NotificationAdd,
  People,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import {
  Card,
  FormControlLabel,
  FormGroup,
  Icon,
  Pagination,
  Stack,
  IconButton,
  Switch,
  Select,
  MenuItem,
} from "@mui/material";
import AstrieskIcon from "components/AstrieskIcon";
import MDBadge from "components/MDBadge";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import SkLoading from "components/SkLoading";
import SkModal from "components/SkModal";
import { useMaterialUIController } from "context";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleAlert } from "redux/festures/alertSlice";
import { patchUser } from "redux/festures/userSlice";
import { getAllUsers } from "redux/festures/userSlice";
import { getAllGlobalUsers } from "redux/festures/userSlice";
import MDInput from "components/MDInput";
import { getSingleUser } from "redux/festures/userSlice";
import { createNotification } from "redux/festures/userSlice";
import SinglePartnerProfile from "Pages/PartnerProfile/SinglePartnerProfile";

const columns = [
  { Header: "S.No", accessor: "no" },
  { Header: "Partner Details", accessor: "user details", width: "20%" },
  { Header: "Mobile/Email", accessor: "mobile/email", width: "20%" },
  { Header: "Products/Services", accessor: "products/services", width: "20%" },
  { Header: "Profile Verification", accessor: "profile verification", width: "20%" },
  { Header: "Vendor Type", accessor: "vendorType" },
  { Header: "Block/Unblock", accessor: "block/unblock" },
  { Header: "Send Notification", accessor: "send Notification" },
  { Header: "View", accessor: "view", textAlign: "center" },
];

const Partners = () => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const admin = localStorage.getItem("admin_id");
  const dispatch = useDispatch();

  const [rowsData, setRowsData] = useState([]);
  const [isUserDetails, setIsUserDetails] = useState(false);
  const [isNotificationOn, setIsNotificationOn] = useState(false);
  const [isSingleUser, setIsSingleUser] = useState(false);
  const [viewUserId, setViewUserId] = useState("");
  const [isSearch, setIsSearch] = useState("");
  const [isFilterName, setIsFilterName] = useState("search");
  const [pagess, setPagess] = useState(1);
  const ITEMS_PER_PAGE = 20;
  const [isSwitch, setIsSwitch] = useState(null);
  const [isRefresh, setIsRefresh] = useState(null);
  const [selectedPartnerId, setSelectedPartnerId] = useState(null);
  const [selectedPartnerName, setSelectedPartnerName] = useState("");

  const { AllUsers, Loading, isPages, singleUsers } = useSelector((state) => ({
    ...state.isUsers,
  }));

  const handleSwitchUpdate = (items) => {
    dispatch(
      patchUser({
        url: `${process.env.REACT_APP_APII}/disablepartnerProfile/${items}/${admin}`,
      })
    ).then((data) => {
      dispatch(
        handleAlert({
          isOpen: true,
          type: `${data?.payload?.success ? "success" : "error"}`,
          msg: data?.payload?.message,
        })
      );
      if (data?.payload?.success) {
        isReloadedData();
      }
    });
  };

  useEffect(() => {
    isReloadedData();
  }, [pagess, isSearch, isFilterName, isRefresh, isSwitch]);

  const isReloadedData = () => {
    dispatch(
      getAllUsers(
        `/getAllpartnerProfile/${admin}/?page=${pagess}&limit=20${
          isSearch !== "" ? `&${isFilterName}=${isSearch}` : ""
        }`
      )
    ).then((data) => {
      if (data?.payload?.data && data?.payload?.data?.length > 0) {
        const temprows =
          data?.payload?.data &&
          data?.payload?.data?.length > 0 &&
          data?.payload?.data?.map((value, index) => ({
            no: (
              <MDTypography sx={{ fontSize: 12, fontWeight: "medium" }} variant="text">
                {(pagess - 1) * ITEMS_PER_PAGE + index + 1}
              </MDTypography>
            ),
            "user details": (
              <MDBox
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  gap: 1,
                }}
              >
                <MDBox sx={{ height: 40, width: 40 }}>
                  <img
                    src={`${process.env.REACT_APP_URI}/${value?.selfie?.image}`}
                    alt={"img"}
                    onError={(e) => {
                      ((e.onError = null),
                        (e.target.src = require("../../assets/images/bg-profile.png")));
                    }}
                    style={{ width: "100%", height: "100%", borderRadius: "50%" }}
                  />
                </MDBox>
                <MDBox
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                  }}
                >
                  <MDTypography
                    sx={{ fontSize: 12, fontWeight: "medium" }}
                    variant="text"
                    style={{
                      maxWidth: "350px",
                      lineHeight: "20px",
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 2,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Name: {value?.name || "-"}
                  </MDTypography>
                  <MDTypography sx={{ fontSize: 12, fontWeight: "medium" }} variant="text">
                    PartnerId: {value?._id || "-"}
                  </MDTypography>
                </MDBox>
              </MDBox>
            ),
            "profile verification": (
              <MDBadge
                badgeContent={
                  value?.idDocument?.profileVerificetionCompleted ? "Completed" : "Not Completed"
                }
                color={value?.idDocument?.profileVerificetionCompleted ? "success" : "error"}
                variant="gradient"
                size="lg"
              />
            ),
            vendorType: (
              <MDTypography sx={{ fontSize: 12, fontWeight: "medium" }} variant="text">
                {value?.vendorType || "NULL"}
              </MDTypography>
            ),
            "mobile/email":
              value?.email || value?.phoneNumber ? (
                <>
                  {value?.email && (
                    <MDTypography
                      display="block"
                      sx={{ fontSize: 12, fontWeight: "medium" }}
                      variant="text"
                      ml={1}
                      style={{
                        maxWidth: "350px",
                        lineHeight: "20px",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      Email: {value?.email || "-"}
                    </MDTypography>
                  )}

                  {value?.phoneNumber && (
                    <MDTypography
                      display="block"
                      sx={{ fontSize: 12, fontWeight: "medium" }}
                      variant="text"
                      ml={1}
                    >
                      Mobile No : {value?.phoneNumber}{" "}
                    </MDTypography>
                  )}
                </>
              ) : (
                "-"
              ),
            "products/services": (
              <>
                <MDTypography
                  display="block"
                  sx={{ fontSize: 12, fontWeight: "medium" }}
                  variant="text"
                  ml={1}
                  style={{
                    maxWidth: "350px",
                    lineHeight: "20px",
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 2,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  Total Products: {value?.totalProducts || "0"}
                </MDTypography>

                <MDTypography
                  display="block"
                  sx={{ fontSize: 12, fontWeight: "medium" }}
                  variant="text"
                  ml={1}
                >
                  Total Services: {value?.totalServices || "0"}
                </MDTypography>
              </>
            ),
            view: (
              <>
                <IconButton
                  aria-label="action_edit"
                  onClick={() => {
                    setIsUserDetails(true);
                    setViewUserId(value);
                    dispatch(getSingleUser(`/getBypartnerProfileId/${value?._id}/${admin}`));
                  }}
                >
                  <Visibility
                    sx={({ palette: { dark, white, info } }) => ({
                      color: darkMode ? info.main : dark.main,
                    })}
                  />
                </IconButton>
              </>
            ),
            "block/unblock": (
              <Switch
                value={value?.disable}
                checked={value?.disable}
                color={"info"}
                onChange={(e) => {
                  handleSwitchUpdate(value?._id);
                  setIsSwitch(!isSwitch);
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
            ),
            "send Notification": (
              <>
                <IconButton
                  aria-label="msg send"
                  onClick={() => {
                    setIsNotificationOn(true);
                    setIsSingleUser(true);
                    setSelectedPartnerId(value?._id);
                    setSelectedPartnerName(value?.name || "Partner");
                  }}
                >
                  <NotificationAdd
                    sx={({ palette: { dark, white, info } }) => ({
                      color: darkMode ? info.main : dark.main,
                    })}
                  />
                </IconButton>
              </>
            ),
          }));
        setRowsData(temprows);
      } else {
        setRowsData([]);
      }
    });
  };

  const [isFormData, setIsFormData] = useState({
    message: "",
    title: "",
  });

  const handleForm = (e) => {
    const { name, value } = e.target;
    setIsFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    if (isSingleUser) {
      if (!selectedPartnerId) {
        dispatch(
          handleAlert({
            isOpen: true,
            type: "error",
            msg: "Partner not selected",
          })
        );
        return;
      }

      dispatch(
        createNotification({
          url: `${process.env.REACT_APP_API}/sendNotificationToSinglePartner`,
          data: {
            ...isFormData,
            partnerId: selectedPartnerId,
          },
        })
      ).then((data) => {
        dispatch(
          handleAlert({
            isOpen: true,
            type: data?.payload?.success ? "success" : "error",
            msg: data?.payload?.message,
          })
        );

        setIsSingleUser(false);
        setIsNotificationOn(false);
        setSelectedPartnerId(null);
        setSelectedPartnerName("");
        setIsFormData({
          title: "",
          message: "",
        });
      });
    } else {
      dispatch(
        createNotification({
          url: `${process.env.REACT_APP_API}/sendNotificationToAllPartner`,
          data: isFormData,
        })
      ).then((data) => {
        dispatch(
          handleAlert({
            isOpen: true,
            type: data?.payload?.success ? "success" : "error",
            msg: data?.payload?.message,
          })
        );

        setIsSingleUser(false);
        setIsNotificationOn(false);
        setIsFormData({
          title: "",
          message: "",
        });
      });
    }
  };

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox mb={2} />
        <MDBox py={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <MDTypography variant="h6" color="white">
                Partner &apos;s Table{" "}
              </MDTypography>
              <MDButton
                variant="gradient"
                color="dark"
                disabled={Loading}
                sx={({ palette: { dark, white, info } }) => ({
                  color: white.main,
                  backgroundColor: dark.main,
                  "&:hover": {
                    color: white.main,
                    backgroundColor: dark.main,
                  },
                })}
                onClick={() => {
                  setIsNotificationOn(true);
                  setIsSingleUser(false);
                }}
              >
                <NotificationAdd />
                &nbsp; Send to all Partner Notification
              </MDButton>
            </MDBox>
            <MDBox
              px={3}
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 0.5,
              }}
            >
              <MDBox
                py={3}
                sx={{
                  flexDirection: "column",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: 1.5,
                }}
              >
                <MDTypography variant="button">Partner Filter</MDTypography>
                <Select
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  value={isFilterName}
                  disabled={Loading}
                  onChange={(e) => {
                    setIsFilterName(e.target.value);
                    setPagess(1);
                    if (e.target.value === "disable") setIsSearch(false);
                    else setIsSearch("");
                  }}
                  sx={({ palette: { dark, white, info } }) => ({
                    width: 100,
                    height: "3rem",
                    color: darkMode ? white?.main : dark?.main,
                    bgcolor: "transparent",
                    "&\t.MuiSelect-icon": {
                      color: darkMode ? white?.main : dark?.main,
                      display: "block !important",
                      fontSize: "1.5rem !important",
                    },
                  })}
                >
                  <MenuItem checked value={"search"}>
                    Search
                  </MenuItem>
                  <MenuItem value={"vendorType"}>Vendor Type</MenuItem>
                  <MenuItem value={"disable"}>Visibility</MenuItem>
                </Select>
              </MDBox>
              <MDBox
                pt={4}
                px={1}
                sx={{
                  flexDirection: "column",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: 1.5,
                }}
              >
                {isFilterName === "search" ? (
                  <MDInput
                    disabled={Loading}
                    placeholder="search here...... "
                    type="text"
                    fullWidth
                    name="sarch here"
                    value={isSearch}
                    onChange={(e) => {
                      setIsSearch(e.target.value);
                      setPagess(1);
                    }}
                  />
                ) : isFilterName === "vendorType" ? (
                  <Select
                    disabled={Loading}
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={isSearch}
                    onChange={(e) => {
                      setPagess(1);
                      setIsSearch(e.target.value);
                    }}
                    fullWidth
                    sx={({ palette: { dark, white, info } }) => ({
                      width: "10rem",
                      height: "3rem",
                      color: darkMode ? white?.main : dark?.main,
                      bgcolor: "transparent",
                      "&\t.MuiSelect-icon": {
                        color: darkMode ? white?.main : dark?.main,
                        display: "block !important",
                        fontSize: "1.5rem !important",
                      },
                    })}
                  >
                    <MenuItem checked value={""}>
                      Choose Vendor Type
                    </MenuItem>
                    <MenuItem value={"ECOMMERCE"}>ECOMMERCE</MenuItem>
                    <MenuItem value={"SERVICE"}>SERVICE</MenuItem>
                    <MenuItem value={"NULL"}>NULL</MenuItem>
                  </Select>
                ) : (
                  <Select
                    disabled={Loading}
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={isSearch}
                    onChange={(e) => {
                      setPagess(1);
                      setIsSearch(e.target.value);
                    }}
                    fullWidth
                    sx={({ palette: { dark, white, info } }) => ({
                      width: "10rem",
                      height: "3rem",
                      color: darkMode ? white?.main : dark?.main,
                      bgcolor: "transparent",
                      "&\t.MuiSelect-icon": {
                        color: darkMode ? white?.main : dark?.main,
                        display: "block !important",
                        fontSize: "1.5rem !important",
                      },
                    })}
                  >
                    <MenuItem checked value={0}>
                      Choose Visibility
                    </MenuItem>
                    <MenuItem checked value={false}>
                      Active Partner
                    </MenuItem>
                    <MenuItem value={true}>Disabled Partner</MenuItem>
                  </Select>
                )}
              </MDBox>
            </MDBox>
            <MDBox py={3}>
              {Loading ? (
                <SkLoading />
              ) : AllUsers && AllUsers.length > 0 ? (
                <>
                  <DataTable
                    table={{
                      columns: columns,
                      rows: rowsData,
                    }}
                    isSorted={false}
                    entriesPerPage={false}
                    isPages={AllUsers && AllUsers.length}
                    noEndBorder
                    canSearch={false}
                    showTotalEntries={false}
                    pagination={false}
                    isPagination={false}
                  />
                  <MDBox
                    sx={{
                      mt: 5,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Stack spacing={2} direction={"row"}>
                      <Pagination
                        sx={({ palette: { dark, white, info } }) => ({
                          "&.MuiPaginationItem-text": {
                            color: darkMode ? white.main : dark.main,
                          },
                          "&\t.MuiPaginationItem-icon": {
                            color: darkMode ? white.main : dark.main,
                          },
                          "&\t\t.MuiPaginationItem-textInfo": {
                            color: darkMode ? white.main : dark.main,
                          },
                        })}
                        color="info"
                        variant="text"
                        count={isPages}
                        page={pagess}
                        onChange={(e, value) => setPagess(value)}
                      />
                    </Stack>
                  </MDBox>
                </>
              ) : (
                <MDBox display="flex" justifyContent="center" gap={2} alignItems="center">
                  <MDTypography variant="h5">Partners Not Found ...!</MDTypography>
                </MDBox>
              )}
            </MDBox>
          </Card>
        </MDBox>
        <Footer />
      </DashboardLayout>
      <SkModal
        show={isUserDetails}
        unShow={setIsUserDetails}
        width={{ sx: "100%", md: "40%", xl: "40%", sm: "100%" }}
        height={"80%"}
        padding={3}
        overflowY={true}
      >
        <SinglePartnerProfile
          viewUserId={viewUserId}
          setViewProductModal={setIsUserDetails}
          isUserDetails={isUserDetails}
          setViewUserId={setViewUserId}
          isRefresh={isRefresh}
          setIsRefresh={setIsRefresh}
          isReloadedData={isReloadedData}
        />
      </SkModal>
      <SkModal
        show={isNotificationOn}
        unShow={setIsNotificationOn}
        width={{ sx: "100%", md: "30%", xl: "30%", sm: "100%" }}
        height={"80%"}
        padding={3}
        overflowY={true}
      >
        <MDBox
          display="flex"
          alignItems="center"
          lineHeight={1}
          sx={{
            justifyContent: "center",
            textAlign: "center",
            flexDirection: "column",
            gap: 5,
            width: "100%",
          }}
        >
          <Card
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 , 10px",
            }}
          >
            <MDTypography variant="h6" py={0.9}>
              {isSingleUser
                ? `Send Notification to ${selectedPartnerName}`
                : "Send to all Partner Notification"}
            </MDTypography>
          </Card>
        </MDBox>
        <MDBox
          display="flex"
          alignItems="center"
          lineHeight={1}
          sx={({ palette: { dark, white, info } }) => ({
            border: 0.5,
            borderColor: darkMode ? white.main : dark.main,
            borderRadius: 3,
            p: 3,
            justifyContent: "center",
            textAlign: "center",
            flexDirection: "column",
            gap: 3,
            width: "100%",
            my: 2,
          })}
          component="form"
          role="form"
          onSubmit={handleFormSubmit}
        >
          <MDBox
            lineHeight={1}
            gap={1}
            width={"90%"}
            justifyContent="flex-start"
            alignItems="flex-start"
            display="flex"
            flexDirection="column"
          >
            <MDTypography variant="h6">
              Notification Title <AstrieskIcon />
            </MDTypography>
            <MDInput
              required={true}
              type="text"
              placeholder="Notification Title"
              fullWidth
              name="title"
              value={isFormData?.title}
              onChange={handleForm}
            />
          </MDBox>

          <MDBox
            lineHeight={1}
            gap={1}
            width={"90%"}
            justifyContent="flex-start"
            alignItems="flex-start"
            display="flex"
            flexDirection="column"
          >
            <MDTypography variant="h6">
              Notification Message <AstrieskIcon />
            </MDTypography>
            <MDInput
              required={true}
              type="text"
              placeholder="Notification Message"
              fullWidth
              name="message"
              value={isFormData?.message}
              onChange={handleForm}
              multiline
              rows={5}
            />
          </MDBox>

          <MDBox
            sx={{
              width: "100%",
              justifyContent: "flex-end",
              textAlign: "center",
              display: "flex",
            }}
          >
            {" "}
            <MDButton color={"info"} verdant={"gradient"} type={"submit"}>
              {isSingleUser
                ? `Send Notification to ${selectedPartnerName}`
                : "Send to all Partner Notification"}
            </MDButton>
          </MDBox>
        </MDBox>
      </SkModal>
    </>
  );
};

export default Partners;
